"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.populateValues = populateValues;
exports.DefaultValues = void 0;
var DefaultValues = {
  string: "",
  number: 0,
  "boolean": false
};
exports.DefaultValues = DefaultValues;

function populateValues(_ref) {
  var model = _ref.model,
      instance = _ref.instance;
  var values = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = model.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var field = _step.value; // TODO: warn type mismatch

      var value = instance && instance[field.name];

      if (value === undefined) {
        if (field.defaultValue !== undefined) {
          value = field.defaultValue;
        } else {
          // give it reasonable default based on type
          value = DefaultValues[field.type];
        }
      }

      values[field.name] = value;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return values;
}